<script>
   /*************************************************************
   * ResultsTable                                               *
   * -------------------------                                  *
   * shows table with SIMCA results for alternative set         *
   **************************************************************/

   // main properties of the whole app
   export let res;
   export let ncomp;

   $: resa = res && ncomp > 0 ? res.v[ncomp - 1] : null;
</script>


{#if resa}
<table>
   <tr>
      <th></th>
      <th>New</th>
   </tr>
   <tr>
      <td class="label">Objects</td>
      <td>{res.nrows}</td>
   </tr>
   <tr>
      <td class="label">In</td>
      <td>{resa.dnum.in}</td>
   </tr>
   <tr>
      <td class="label">Out</td>
      <td>{resa.dnum.out}</td>
   </tr>
   <tr>
      <td class="label">Aliens</td>
      <td>{resa.anum.aliens}</td>
   </tr>
   <tr>
      <td class="label">External</td>
      <td>{resa.anum.external}</td>
   </tr>
   <tr>
      <td class="label">Specificity</td>
      <td>{res.stat.specificity[ncomp - 1].toFixed(3)}</td>
   </tr>
   <tr>
      <td class="label">Selectivity</td>
      <td>{res.stat.selectivity[ncomp - 1].toFixed(3)}</td>
   </tr>
</table>
{/if}

<style>
   table {
      width: 100%;
      border-collapse: collapse;
   }

   tr {
      width: 100%;
   }

   th {
      border-bottom: 1px solid #a0a0a0;
   }

   th, td {
      text-align: right;
      padding: 0.2em 0.5em 0.2em 0.1em;
      color: #404040;
      margin: 0;
   }

   .label {
      text-align: left;
      padding: 0.1em 0.5em;
   }
</style>